import { Select } from "antd";
import styled from "styled-components";

export const AssigneeSelect = styled(Select)`
  width: 100%;
  margin-top: 12px;
`;
